
<div>
    <c-column-header
        class="primary"
        :label="title"
    >
        <template v-slot:filter>
            <div style="margin-top: -1px">
                <c-toolbar-button
                    icon     = "mdi-refresh"
                    :tooltip = "$t('common.refresh')"
                    color    = "white"
                    size     = "20"
                    @click   = "onRefresh"
                />
            </div>
        </template>
    </c-column-header>
    <v-progress-linear
        v-if   = "loading"
        color  = "secondary"
        height = "4"
        class  = "w-100 mt-0"
        indeterminate
    />
    <div class="mt-1" v-if="!loading">

    </div>
    <div class="mt-0 lm-border pa-2" style="height: 430px">
        <div class="pr-1" style="overflow-y: scroll; max-height: 412px;">
            <!-- iot-api-svc's /sites/{id}/events only guarantees triggeredAt/receivedAt/type for a
                 RIDE event - the old per-door/per-direction sensor icons relied on fields
                 (direction, sensor, recorded) the new event model doesn't provide, so rides are
                 now shown as a plain timestamp list. -->
            <div v-for="(movement, index) in movements" :key="index" class="v-flex ml-5 ride-row">
                <div class="vMovement">
                    <v-icon color="white">mdi-elevator</v-icon>
                </div>

                <div class="pl-2" style="font-size: 15px">
                    {{ format (movement.triggeredAt) }}
                </div>
            </div>
        </div>
    </div>
</div>
